module.exports = __webpack_public_path__ + "static/media/asset_down.26dcac92.svg";